import styled from "styled-components";
import { Font, Color, breakpoints } from "@/shared/Constants";

export const DespieceContainer = styled.div`
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
  padding-top: 20px;
  border: 1px solid ${Color.greySeparator};
  border-radius: 10px;
  font-size: 20px;
  ${Font.sansLight};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 32px;
  text-align: left;
  line-height: 25px;
  color: black;
  p,
  a {
    display: inline;
  }
  a {
    border-bottom: 1px solid ${Color.mainColor};;
    transition: background-color 5s linear;
    color: ${Color.black000};
    &:hover {
      color: #000;
    }
  }
  picture img {
    margin-top: -25px;
    z-index: 0;
  }

  picture span {
    ${Font.sansSemiBold};
    font-size: 15px;
    color: #ffffff;
    display: inline-block;
    position: relative;
    z-index: 2;
    top: -45px;
    width: 100%;
    text-align: center;
  }
  strong {
    ${Font.sansBold};
  }
  b {
    ${Font.sansBold};
  }
  ol {
    list-style-type: none;
    counter-reset: custom-counter;
    padding: 0;
  }

  ol li {
    list-style-type: none;
    position: relative;
    margin-bottom: 22px;
    padding-left: 40px;
  }
  ol li::after {
    content: counter(custom-counter);
    box-sizing: border-box;

    border-radius: 50px;
    border: 1px solid ${Color.black};
    height: 26px;
    width: 26px;
    position: absolute;
    z-index: 1;
    counter-increment: custom-counter;
    ${Font.sansBold};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    top: 2px;
    left: 0px;
    padding-top: 1px;
  }

  ul {
    padding: 14px 0 0 14px;
  }

  ul li {
    margin-bottom: 20px;
    color: black;
    list-style-type: none;
    position: relative;
    display: inline-block;
  }

  ul li::before {
    content: url("/img/Ellipse221.svg");
    position: absolute;
    top: -5px;
    margin-left: -14px;
  }

  .DespieceTitle {
    width: 100%;
    ${Font.sansBold};
    border-bottom: 1px solid ${Color.greySeparator};
    padding-bottom: 20px;
    margin-bottom: 25px;
  }
  ${breakpoints.phone} {
    font-size: 19px;
    .DespieceTitle {
      margin-bottom: 20px;
    }
    picture img {
      margin-bottom: 5px;
      margin-top: -20px;
    }
    picture span {
      text-align: left;
      ${Font.sansRegular};
      font-size: 15px;
      color: ${Color.grey};
      display: inline-block;
      margin-bottom: 10px;
      top: 0px;
    }
  }
`;
